import React from "react";
import Link from "next/link";
import { cn } from "@rosette/ts/src/util/cn.js";
import BackArrow from "@rosette/web_components/src/icon/BackArrow.js";


export interface ArticleDirPiece {
    label: string;
    href: string;
}


interface ArticleDirProps {
    className?: string;
    dir: ArticleDirPiece[];
}


export default function ArticleDir({
    className, dir,
}: ArticleDirProps) {
    return (
        <div className={cn(
            "flex flex-row items-center text-xl max-md:mt-4",
            className ?? null,
        )}>
            {dir.map((piece, index) => (
                <div
                    className="flex flex-row items-center"
                    key={`p${index}`}>

                    {index > 0 && (
                        <>
                            &nbsp;/&nbsp;
                        </>
                    )}

                    <Link
                        className={cn(
                            "flex flex-row items-center max-w-max whitespace-nowrap cursor-pointer",
                            "text-body hover:text-strong hover:underline",
                        )}
                        href={piece.href}>

                        {dir.length === 1 && (
                            <BackArrow />
                        )}
                        <span>
                            {piece.label}
                        </span>
                    </Link>
                </div>
            ))}
        </div>
    );
}
